import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

/**
 * Fetches advance request (ARQ) data for a purchase order.
 * @param {string} purchaseOrderId - PO id (required for fetch)
 * @returns useQuery result with data in shape: { data: advancePurchaseOrder[] }
 */
const fetchAdvanceRequestPurchaseOrder = (purchaseOrderId) => {
  if (!purchaseOrderId) return Promise.resolve({ data: [] });
  const url = `${apiurl?.getAdvanceRequestPurchaseOrder}?purchaseOrderId=${encodeURIComponent(purchaseOrderId)}`;
  return axios.get(url);
};

const getAdvanceRequestPurchaseOrder = (purchaseOrderId, options = {}) => {
  const { enabled = true } = options;
  return useQuery(
    ['getAdvanceRequestPurchaseOrder', purchaseOrderId],
    () => fetchAdvanceRequestPurchaseOrder(purchaseOrderId),
    { enabled: !!purchaseOrderId && enabled, refetchOnWindowFocus: false }
  );
};

export default getAdvanceRequestPurchaseOrder;
export { fetchAdvanceRequestPurchaseOrder };
